<template>
  <div>
    <MenuPromotion/>
    <Promotion_product_exp/>
  </div>
</template>

<script>
import MenuPromotion from "@/components/admin/stock/storage_promotion/menupromotion/MenuPromotion";
import Promotion_product_exp from "@/components/admin/stock/storage_promotion/Promotion_product_exp";
export default {
  name: "PromotionProductExp",
  components: {
    Promotion_product_exp,
    MenuPromotion
  }
}
</script>

<style scoped>

</style>
